import React, { Component } from 'react';

import SwipeableViews from 'react-swipeable-views';

import { IClubsActions } from '../../../store/player/clubs/actions';
import { IClubsStore } from '../../../store/player/clubs/store';

import { withContext } from '../../../contrib/utils';
import BackToTop from '../../../components/BackToTop';
import Select from '../../../components/Select';
import OfficerAvatar from './OfficerAvatar/OfficerAvatar';
import { EmptyItem } from './EmptyItem';

type ActiveType = 'about' | 'officers';

interface IProps {
  actions: {
    clubs: IClubsActions;
  };
  clubId: string;
  clubs: IClubsStore;
}

interface IState {
  active: ActiveType;
  swipeIndex: number;
}

class ClubAboutComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      active: 'about',
      swipeIndex: 0
    };

    props.actions.clubs.get(Number(props.clubId));
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.clubId !== this.props.clubId) {
      props.actions.clubs.get(Number(props.clubId));
    }
  }

  public select = (selected: { value: string }): void => {
    this.handleChange(selected.value);
    this.setState({ active: selected.value as ActiveType });
  };

  public handleChange = (value: string) => {
    if (value === 'about') {
      this.setState({ swipeIndex: 0 });
    } else {
      this.setState({ swipeIndex: 1 });
    }
  };

  public handleChangeIndex = (index: number): void => {
    this.setState({ swipeIndex: index });
  };

  public render(): JSX.Element {
    const { clubs, clubId } = this.props;
    const club = clubs[Number(clubId)] || {};

    const options = [
      { label: 'CLUB INFO', value: 'about' },
      { label: 'OFFICERS', value: 'officers' }
    ];

    return (
      <div className="home club-about wrapper">
        <div className="club-about-inner-wrapper override">
          <h2 className="club-about__title">ABOUT THE CLUB</h2>

          <Select title="FILTER" options={options} onSelect={this.select} />

          {!!club.email && (
            <SwipeableViews
              animateHeight={true}
              disabled={true}
              enableMouseEvents={false}
              axis={'x'}
              index={this.state.swipeIndex}
              onChangeIndex={this.handleChangeIndex}
            >
              <div className="club-info-body">
                <h3 className="club-info-body__subtitle">HOME COURSE</h3>

                <p>{club.course && club.course.name}</p>

                <p>{club.course && club.course.address}</p>

                <h3 className="club-info-body__subtitle">CONTACT INFORMATION</h3>

                <p>{club.email}</p>

                <h3 className="club-info-body__subtitle">About The Club</h3>

                <p>{club.description}</p>
              </div>

              <div className="club-officers-body">
                {club.managements !== undefined && club.managements.length !== 0 ? (
                  club.managements.map((officer, index) => (
                    <OfficerAvatar index={index} officer={officer} />
                  ))
                ) : (
                  <EmptyItem />
                )}
              </div>
            </SwipeableViews>
          )}

          <BackToTop className="back-to-top--club-about" delayInMs={16.66} scrollStepInPx={50} />
        </div>
      </div>
    );
  }
}

const ClubAbout = withContext(ClubAboutComponent, 'clubs');

export default ClubAbout;
